import { FC } from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { themeColor } from '../layout/theme/color'

interface InfoCardProps {
  title?: string
  children: React.ReactNode
}

interface InfoCardRowProps {
  label: string
  value: React.ReactNode
}

export const InfoCardRow: FC<InfoCardRowProps> = ({ label, value }) => (
  <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ py: 0.75 }}>
    <Typography variant="caption" sx={{ color: themeColor.slate50, fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
      {label}
    </Typography>
    <Typography variant="body2" sx={{ fontWeight: 600 }}>
      {value ?? '-'}
    </Typography>
  </Stack>
)

export const InfoCard: FC<InfoCardProps> = ({ title, children }) => (
  <Stack spacing={0}>
    {title && (
      <Typography
        variant="caption"
        sx={{
          fontWeight: 600,
          color: 'rgba(0,0,0,0.35)',
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
          mb: 1,
          display: 'block',
        }}
      >
        {title}
      </Typography>
    )}
    {children}
  </Stack>
)
